import { render, staticRenderFns } from "./ConfigWebsiteCataloguesView.vue?vue&type=template&id=bb19f010"
import script from "./ConfigWebsiteCataloguesView.vue?vue&type=script&lang=js"
export * from "./ConfigWebsiteCataloguesView.vue?vue&type=script&lang=js"
import style0 from "./ConfigWebsiteCataloguesView.vue?vue&type=style&index=0&id=bb19f010&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports